import { format, parseISO } from "date-fns";

/** Convert a `<input type="datetime-local">` string (no tz) to UTC ISO. */
export const localDateTimeToUtc = (localDateTime: string): string => {
  const local = new Date(localDateTime);
  return local.toISOString();
};

/** Convert UTC ISO/Date to a `<input type="datetime-local">` string in the
 *  user's local timezone (yyyy-MM-ddTHH:mm). */
export const utcDateTimeToLocal = (utcDateTime: string | Date): string => {
  const date =
    typeof utcDateTime === "string"
      ? parseISO(utcDateTime)
      : new Date(utcDateTime);
  return format(date, "yyyy-MM-dd'T'HH:mm");
};
